import {
  arrayOf as arrayOfType,
  shape as shapeType,
  string as stringType,
  bool as boolType,
  params,
} from '@thd-nucleus/data-sources';

export const PromoCartProviderDataModel = {
  itemPromotionValidity: params({
    navParam: stringType().isRequired(),
    storeSkuIds: arrayOfType(stringType().isRequired()).isRequired(),
  }).arrayOf(shapeType({
    storeSkuId: stringType(),
    eligible: boolType(),
  })),
};
